export enum AdminActivityStepsTableColumnDataIndex {
  Step = "step",
  StepType = "stepType",
  StepName = "stepName",
  Options = "options",
}
